// General Chart Functions
// Trim sequence id

import { isNullOrUndefined, isNumeric } from "./generalFunctions"
import * as con from "../Constants"


export const ALIGNMENT_BREAKS = [100, 400, 500, 600]

export const getAlignmentBreakIndex = (val) => {
    if (isNullOrUndefined(val) || !isNumeric(val))
        return null

    // Forces float
    val = parseFloat(val)

    if (val >= ALIGNMENT_BREAKS[ALIGNMENT_BREAKS.length - 1])
        return ALIGNMENT_BREAKS.length - 1

    let resp = ALIGNMENT_BREAKS.findIndex(b => b > val)

    return (resp)



}


export const trimSequenceId = (sequenceId, maxLength = 20) => {

    if (isNullOrUndefined(sequenceId))
        return sequenceId

    // Forces String
    sequenceId = `${sequenceId}`

    if (sequenceId.length <= maxLength)
        return sequenceId


    const chunkLength = Math.floor((maxLength - 3) / 2)

    return `${sequenceId.slice(0, chunkLength)}...${sequenceId.slice(sequenceId.length - chunkLength, sequenceId.length)}`

}


export const formatEValue = (eValue) => {

    if (isNullOrUndefined(eValue))
        return eValue

    // For zero values, return as-is (numeric 0)
    if (eValue === 0) {
        return eValue;
    }

    // For very small values (typically in scientific notation), format with 2 decimal places
    if (eValue < 0.01) {
        return parseFloat(eValue).toExponential(2);
    }

    // For larger values, return as-is
    return eValue;

}

export function constructAlignmentString(alignment) {

    let q = alignment[con.ARC_QSEQ]
    let m = alignment[con.ARC_MIDLINE]
    let s = alignment[con.ARC_SSEQ]

    return (`${q}\n${m}\n${s}`)
}

export function parseTaxonomicLine(line) {

    const levels = [
        con.ID,
        ...con.TAXONOMIC_LEVELS
    ];

    const parts = line.split(";");

    const result = {};
    levels.forEach((level, i) => {
        result[level] = parts[i] && parts[i].trim() !== "." ? parts[i].trim() : null;
    });

    return result;
}

export function getTaxomomicId(line) {

    let taxonomicValues = parseTaxonomicLine(line)

    let taxonomicId = con.TAXONOMIC_LEVELS.map(level => taxonomicValues[level]).filter(value => !isNullOrUndefined(value)).join(";")

    return taxonomicId
}


/**
 * Generates an SVG path string representing a directional arrow between two points along the query sequence.
 *
 * The arrow is a horizontal, filled polygon with a pointed head on the right (or left, 
 * depending on orientation) and straight sides. The shape maintains constant height
 * and includes a customizable arrowhead width.
 *
 * @param {number} startX - The starting X-coordinate of the arrow (tail).
 * @param {number} endX - The ending X-coordinate of the arrow (head).
 * @param {number} startY - The top Y-coordinate of the arrow (top of the bounding box).
 * @param {number} endY - The bottom Y-coordinate of the arrow (bottom of the bounding box).
 * @param {number} [arrowHeadWidth=6] - The width of the arrowhead in pixels.
 * @param {string} [orientation=con.RIGHT] - Direction of the arrow. Currently only supports `con.RIGHT` and `con.LEFT`.
 *
 * @returns {string} An SVG path string (`d` attribute) representing the arrow shape.
 */
export const buildArrow = (startX, endX, startY, endY, arrowHeadWidth = 6, orientation = con.RIGHT) => {


    // Ensure arrow head doesn't exceed total width
    const clampedArrowHeadWidth = Math.min(arrowHeadWidth, (endX - startX) / 2);

    // Offsets the start and set the multiplier for orientation
    let i = 1
    if (orientation === con.RIGHT) {
        startX += arrowHeadWidth
        i = -1

    }

    // Define the path points
    const pathData = [
        `M ${startX} ${((endY - startY) / 2) + startY}`,                // Point A: left tip center
        `L ${startX + i * clampedArrowHeadWidth} ${startY}`,            // Point B: top-left
        `L ${endX + i * clampedArrowHeadWidth} ${startY}`,              // Point C: top-right
        `L ${endX} ${((endY - startY) / 2) + startY}`,                  // Point D: right tip center
        `L ${endX + i * clampedArrowHeadWidth} ${endY}`,                // Point E: bottom-right
        `L ${startX + i * clampedArrowHeadWidth} ${endY}`,              // Point F: bottom-left
        `Z`                                                             // Close path back to Point A
    ].join(" ");


    return pathData
}

export const extractIdFromTaxonomicSequence = (sseqid) => {

    if (isNullOrUndefined(sseqid))
        return sseqid

    // Forces String
    sseqid = `${sseqid}`

    return sseqid.split(";")[0]
}
